import { NEW_MODULE_PATHS, CONDITION_MODULE_PATHS } from '../utils/const';
import { useStyleContextState } from '../modules/styleContext';
import { useEffect, useState } from 'react';

export function useIsNewModule(path: string) {
	const { isCaoWijzerLabel } = useStyleContextState();
	const [validPaths, setValidPaths] = useState(NEW_MODULE_PATHS as Array<string>);

	useEffect(() => {
		if (!isCaoWijzerLabel) {
			setValidPaths((prevState) => [...prevState, ...Object.values(CONDITION_MODULE_PATHS)]);
		}
	}, [isCaoWijzerLabel]);

	return validPaths.some((moduleUrl) => String(moduleUrl).toLowerCase() === String(path).toLowerCase());
}
